// import Modal from './modal';
export * from './modal';
export * from "./modalParent";

// export { ModalParent } from "./modalParent"
// export default Modal;